import {
    apiRequest,
    masterWorkUnit,
    masterEmployeeStatus
} from "../../../../../../services/adapters/kepegawaian/homeService"
import { 
    cutiTypeList,
    signatoriesList,
    cutiDetail,
    cutiApproval,
    cutiKuotaTahunan, 
    cutiChildTypeList,
    getMinDate
} from '../../../../../../services/adapters/kepegawaian/cutiService'


class IndexRepository {

    fetchKuotaTahunan = async (query) => {
        return await apiRequest("get", cutiKuotaTahunan, {
            params: query
        }, true)
    }

    fetchWorkUnit = async (query) => {
        return await apiRequest("get", masterWorkUnit, {
            params: query
        }, true)
    }

    fetchEmployeeStatus = async (query) => {
        return await apiRequest("get", masterEmployeeStatus, {
            params: query
        }, true)
    }

    fetchTypeList = async (query, cancelToken) => {
        return await apiRequest("get", cutiTypeList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

   fetchChildTypeList = async (query, cancelToken) => {
        return await apiRequest("get", cutiChildTypeList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchSignatoriesList = async (query, cancelToken) => {
        return await apiRequest("get", signatoriesList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchDetail = async (query, cancelToken=null) => {
        return await apiRequest("get", cutiDetail, {
            params: query
        }, true)
    }

    fetchApproval = async (query, cancelToken) => {
        return await apiRequest("post", cutiApproval, {
            body: query
        }, true)
    }

    fetchMinDate = async (query, cancelToken) => {
        return await apiRequest("get", getMinDate, {
            params: query
        }, true)
    }
}

export default IndexRepository